import { Component, ReactNode } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/ModuleWrapper/ModuleHeader.css'
import { AnchorPlacement } from 'interfaces/navigation'
import { TooltipIcon } from 'components/atoms/TooltipIcon/TooltipIcon'
import { ModuleSubtitle, ModuleTitle } from 'components/atoms/Text'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

export type ModuleHeaderProps = {
  hint?: ReactNode
  title?: ReactNode
  subtitle?: string
  noPadding?: boolean
  responsive?: boolean
  connected?: boolean
  action?: ReactNode
  titleLinkTo?: AnchorPlacement
  className?: string
}

class ModuleHeader extends Component<ModuleHeaderProps, {}> {
  render () {
    const {
      title,
      action,
      connected = false,
      noPadding,
      responsive,
      className: classNameOuter,
    } = this.props

    if (!title) {
      return null
    }
    const className = cn(styles.moduleHeader, {
      [styles.noPadding]: noPadding,
      [styles.responsive]: responsive,
      [styles.connected]: connected,
    }, classNameOuter)
    return (
      <header className={ className }>
        <div className={ styles.blockName }>
          { this.renderHeaderInner() }
          { this.renderHintIcon() }
        </div>
        { action }
      </header>
    )
  }

  renderHeaderInner = () => {
    const { titleLinkTo } = this.props

    const titleChild = this.renderTitle()
    if (!titleLinkTo) {
      return (
        <div className={ styles.headerInner }>
          { titleChild }
        </div>
      )
    }

    return (
      <NavigationLink to={ titleLinkTo } className={ styles.headerInner }>
        { titleChild }
      </NavigationLink>
    )
  }

  renderTitle = () => {
    const { title, subtitle, titleLinkTo } = this.props

    if (!title) {
      return null
    }

    return (
      <ModuleTitle className={ styles.title }>
        { title }
        { subtitle && <ModuleSubtitle text={ subtitle } className={ styles.subtitle } /> }
        { titleLinkTo && <div className={ styles.rightArrow } /> }
      </ModuleTitle>
    )
  }

  renderHintIcon = () => {
    const { hint, titleLinkTo } = this.props

    if (!hint) {
      return null
    }

    return (
      <div className={ cn(styles.tooltipIconWrapper, { [styles.withChevron]: !!titleLinkTo }) }>
        <TooltipIcon content={ hint } />
      </div>
    )
  }
}

export default ModuleHeader
